import { translateFunc } from "client/utils/translateFunc";
import { AddImageIcon } from "components/common/Icons/AddImageIcon";
import { AddPadingIcon } from "components/common/Icons/AddPaddingIcon";
import { AddTextIcon } from "components/common/Icons/AddTextIcon";
import type { ReactNode } from "react";
import { IconsModal } from "./IconsModal/IconsModal";
import { useButtons } from "./useButtons";

export const Buttons = () => {
    const {
        isPaddingApplied,
        handleAddTextIconClick,
        handlePaddingClick,
        handleUploadClick,
        handleAddIconClick,
        isIconsModalOpen,
        closeIconsModal,
    } = useButtons();
    return (
        <div className="flex flex-col gap-2 px-6">
            <Button
                icon={<AddTextIcon />}
                text={translateFunc("add-text")}
                onClick={handleAddTextIconClick}
                isActive={false}
            />
            <Button
                icon={<AddImageIcon />}
                text={translateFunc("add-icon")}
                onClick={handleAddIconClick}
                isActive={false}
            />
            <Button
                icon={<UploadIcon />}
                text={translateFunc("upload-meme")}
                onClick={handleUploadClick}
                isActive={false}
            />
            <Button
                icon={
                    <AddPadingIcon
                        className={`${isPaddingApplied ? "fill-white" : "fill-irBlue-200 dark:fill-white"}`}
                    />
                }
                text={translateFunc("add-padding")}
                onClick={handlePaddingClick}
                isActive={isPaddingApplied}
            />
            {isIconsModalOpen ? <IconsModal isOpen={isIconsModalOpen} close={closeIconsModal} /> : null}
        </div>
    );
};

interface ButtonProps {
    icon: ReactNode;
    text: string;
    onClick: () => void;
    isActive: boolean;
}

const Button = ({ icon, onClick, text, isActive }: ButtonProps) => (
    <button
        className={`group  border border-irBlue-200 dark:border-darkSurface-400 rounded-xl py-2 flex items-center justify-center
            gap-2 hover:text-white dark:bg-darkSurface-200 hover:bg-irBlue-200 dark:hover:bg-darkSurface-100 ${
                isActive ? "text-white bg-irBlue-200" : "text-irBlue-200 dark:text-white bg-white"
            }`}
        onClick={onClick}
    >
        <span>{icon}</span>
        <span>{text}</span>
    </button>
);

const UploadIcon = () => (
    <svg
        width={25}
        height={24}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="fill-irBlue-200 dark:fill-white group-hover:fill-white"
    >
        <path d="M12.648 10.758a.188.188 0 0 0-.296 0l-2.625 3.32a.187.187 0 0 0 .148.303h1.732v5.681c0 .104.084.188.188.188H13.2a.188.188 0 0 0 .187-.188v-5.679h1.737c.157 0 .244-.18.148-.302l-2.625-3.323Z" />
        <path d="M19.517 8.595a7.503 7.503 0 0 0-7.012-4.845 7.5 7.5 0 0 0-7.013 4.842A4.69 4.69 0 0 0 2 13.125a4.686 4.686 0 0 0 4.685 4.688h.94a.188.188 0 0 0 .188-.188v-1.406a.188.188 0 0 0-.188-.188h-.94a2.905 2.905 0 0 1-2.29-4.697c.392-.499.94-.862 1.55-1.024l.888-.232.326-.858a5.756 5.756 0 0 1 2.065-2.655 5.675 5.675 0 0 1 3.28-1.036c1.184 0 2.319.359 3.282 1.036A5.762 5.762 0 0 1 17.85 9.22l.323.856.886.234a2.92 2.92 0 0 1 2.159 2.815 2.89 2.89 0 0 1-.851 2.056 2.884 2.884 0 0 1-2.053.85h-.94a.188.188 0 0 0-.188.188v1.406c0 .103.085.188.188.188h.94a4.688 4.688 0 0 0 1.202-9.218Z" />
    </svg>
);
